<template>
  <CommonModal>
    <template slot="header">
      <h3>Change Order</h3>
    </template>
    <template slot="body">
      <div @click="sortModel" id="modelList" class="arrow">
        Sort
      </div>
      <draggable  v-model="form.controllerList">
        <div v-for="item in form.controllerList" :key="item.controllerId" class="order-box">
          {{ item.controllerName }}
        </div>
      </draggable>
    </template>
    <template slot="footer">
      <slot name="footer">
      </slot>
    </template>
  </CommonModal>
</template>

<script>
import $ from "jquery";
import {getControllerTypeList, updateControllerOrder} from "@/api/controllertype";
import draggable from 'vuedraggable'
import CommonModal from "@/components/modal/CommonModal";

export default {
  components: {
    CommonModal ,
    draggable
  },
  data() {
    return {
      form : {
        controllerList: [],
      },
    };
  },
  methods: {
    async fetchData(){
      try {
        const response = await getControllerTypeList();
        this.form.controllerList = response.data.controllerTypeList;
      } catch (error) {
        console.log(error);
      }
    },
    async saveOrder() {
      await this.form.controllerList.forEach(function (item, index) {
        item.controllerSort = index;
      });
      await updateControllerOrder(this.form);
    },
    sortModel(){
      let tmp = this.form.controllerList;
      let sortdir = 1;
      if($("#modelList").is(".up")){
        $("#modelList").removeClass("up");
        $("#modelList").addClass("down")
        sortdir = -1;
      }else{
        $("#modelList").addClass("up");
        $("#modelList").removeClass("down")
        sortdir = 1;
      }
      tmp.sort((a, b) => {
        let x = a.controllerName.toUpperCase();
        let y = b.controllerName.toUpperCase();
        return (x < y)?-sortdir:(x>y)?sortdir:0;
      });
      this.form.controllerList = tmp;
    }
  }
}
</script>

<style>

.arrow{
    display: block;
    color: #1a1a1a;
    font-weight: bold;
    line-height: 60px;
    border-bottom: 1px solid #e0e0e0;
}

.arrow:hover{
  cursor: pointer;
}

.up{
    display: block;
    color: #1a1a1a;
    font-weight: bold;
    line-height: 60px;
    background: url(../../img/background/fillter_arr_up.png) no-repeat right 50%;
}

.down{
    display: block;
    color: #1a1a1a;
    font-weight: bold;
    line-height: 60px;
    background: url(../../img/background/fillter_arr_down.png) no-repeat right 50%;
}
</style>